module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 [1, 2, 3, 4, 5, 6].forEach(function(index) { ;
__p += '\n    <dt>\n        <label for="contract-extra-contracted-power-p' +
((__t = ( index )) == null ? '' : __t) +
'">' +
((__t = ( i18next.t('tariffs.required_power') )) == null ? '' : __t) +
' P' +
((__t = ( index )) == null ? '' : __t) +
' (kW)&nbsp;*</label>\n    </dt>\n    <dd>\n        <input class="text" id="contract-extra-contracted-power-p' +
((__t = ( index )) == null ? '' : __t) +
'" name="contract[extra][contracted_power_p' +
((__t = ( index )) == null ? '' : __t) +
']" type="number">\n    </dd>\n';
 }) ;
__p += '\n';

}
return __p
}